/*----------------------------------
- LEGAL DOCUMENT SWITCHER (SSOT)
----------------------------------*/

/**
 * The three legal documents, in the order the switcher shows them.
 *
 * Presentation only: the labels are the short names the segmented control needs
 * ("Refunds" does not fit beside "Terms" as "Refund Policy"), and the paths come
 * from the route catalog so the switcher can never point at a route that moved.
 * Nothing here is legal wording; that stays in each document's `pageContent.ts`.
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { LANDING_WEBSITE_PAGE_ROUTES } from '@/common/catalogs/landing/publicPages';

/*----------------------------------
- TYPES
----------------------------------*/

export type LegalDocumentTab = {
    /** Short label, sized for the segmented control. */
    label: string;
    /** Real route, so the switcher is three links and needs no JS. */
    path: string;
};

/*----------------------------------
- CATALOG
----------------------------------*/

export const LEGAL_DOCUMENT_TABS: readonly LegalDocumentTab[] = [
    { label: 'Terms', path: LANDING_WEBSITE_PAGE_ROUTES.terms },
    { label: 'Privacy', path: LANDING_WEBSITE_PAGE_ROUTES.privacy },
    { label: 'Refunds', path: LANDING_WEBSITE_PAGE_ROUTES.refundPolicy },
];
